import PageHeader from "@/components/PageHeader";
import PlansGrid from "@/components/sections/PlansGrid";
import DomainSearch from "@/components/sections/DomainSearch";
import SEO from "@/components/SEO";

export default function EmailPage() {
  return (
    <main data-testid="email-page">
      <SEO
        title="Business Email Hosting — Custom-Domain Mailboxes | LaneX Labs"
        description="Professional business email on your own domain. Anti-spam and anti-virus, shared calendars, mobile sync and enterprise-grade security. From £3 per mailbox per month."
        path="/email"
      />
      <PageHeader
        overline="Business Email"
        title={<>Email on your own<br /><em className="italic text-gradient">domain</em>.</>}
        lead="Professional business mailboxes with anti-spam, anti-virus, shared calendars, mobile sync and enterprise security — set up and supported by our team."
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-6 -mt-6">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-9">
            <p className="text-[15px] text-[color:var(--text-muted)] leading-relaxed">
              A hello@yourbrand.com address closes deals that gmail addresses can't. Our business
              email is powered by carrier-grade infrastructure with anti-spam and anti-virus filtering,
              DMARC/SPF/DKIM configured out of the box, shared calendars and contacts, mobile push
              (iOS &amp; Android) and web and IMAP/SMTP access. We handle DNS, migration from your
              existing provider, and onboarding for your team.
            </p>
          </div>
        </div>
      </section>

      <PlansGrid kind="email" cta="Choose plan" />

      <DomainSearch />
    </main>
  );
}
